import { collapseIframe } from 'Renderer/domOperations/iFrameOperations';

// global store
const createOutstream = (child) => {
  const width = child.clientWidth;
  const height = child.clientHeight;
  const area = width * height;
  let element = child;
  let lastElement = child;
  let style = element.style || {};
  style.height = '100%';
  style.width = '100%';
};

export const resizeOutstreamViewport = (sessionId, artboard, safeFrame, canAccessIframe) => {
  if (canAccessIframe) {
    const thisWindow = window;
    const windowParent = thisWindow.parent;

    const iframeParent = thisWindow.frameElement.parentNode;

    const creativeFrame = iframeParent.ownerDocument.getElementById("ivoOutstreamFrame-"+sessionId);

    const adjustablePercentage = creativeFrame.clientWidth/artboard.viewport.width;

    creativeFrame.ownerDocument.getElementById('ivoOutStreamContainer-' + sessionId).style.height = (artboard.viewport.height * adjustablePercentage) + 'px';
    creativeFrame.style.height = (artboard.dimensions.height * adjustablePercentage) + 'px';
  }
}

export const createOutstreamContainer = (tagInformation, placementId, rootElementName, canAccessIframe, rootBodyElement) => {
  const dataParagraph = rootBodyElement.getAttribute('data-ivo-para');
  const dataAnchor = rootBodyElement.getAttribute('data-ivo-anchor');
  const dataAchorElement = parent.document.querySelector(dataAnchor);

  let adParent;

  if (canAccessIframe) {
    const thisWindow = window; // eslint-disable-line no-undef
    adParent = thisWindow.frameElement.parentNode;
  } else {
    adParent = tagInformation.element.parentNode;
  }

  try {
    if (!IS_PREVIEW_PAGE) { collapseIframe(); } // eslint-disable-line no-undef

    let artcleDiv = parent.document.body;
    if (parent.document.getElementsByClassName('article__body').length) {
      adParent.closest('div.advert__container').style.cssText = 'padding:0; min-height:0; height:0; overflow:hidden;';
      artcleDiv = parent.document.getElementsByClassName('article__body');
    } else if (parent.document.getElementsByTagName('article').length) {
      artcleDiv = parent.document.getElementsByTagName('article');
    } else if (parent.document.getElementsByClassName('container').length) {
      artcleDiv = parent.document.getElementsByClassName('container');
    }

    let anchorElement = dataAchorElement || artcleDiv[0];

    if (!dataAchorElement) {
      let pCount = 0;
      [...artcleDiv].map((element) => {
        const elementPCount = element.getElementsByTagName('p').length;
        if (elementPCount && (elementPCount > pCount)) {
          const position = dataParagraph ? parseInt(dataParagraph, 10) : 2;
          pCount = elementPCount;
          anchorElement = element.getElementsByTagName('p')[position].nextSibling;
        }
      });
    }

    const outStreamContainer = document.createElement('div'); // eslint-disable-line no-undef
    outStreamContainer.id = `ivoOutStreamContainer-${tagInformation.sessionId}`;
    outStreamContainer.className = 'wayve-ad root';
    outStreamContainer.style.cssText = 'position: relative; width: 100%; min-width: 0px; height:300px; overflow: hidden;';
    anchorElement.parentNode.insertBefore(outStreamContainer, anchorElement);

    const iframe = document.createElement('iframe'); // eslint-disable-line no-undef
    iframe.id = `ivoOutstreamFrame-${tagInformation.sessionId}`;
    iframe.style.cssText = 'border:0;';
    iframe.width = '100%';
    iframe.height = '100%';
    iframe.scrolling = 'no';

    outStreamContainer.appendChild(iframe);

    return iframe;
  } catch (e) {
    console.log('ivo : error rendering outstream container');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/utils/outstreamContainer.js